import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { getDivisionsPerBlock } from '@cpr/shared/cpr-math';

@Pipe({ name: 'divisionsPerBlock', pure: true, standalone: true })
export class DivisionsPerBlockPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  transform(milesPerDivision?: number): string {
    return typeof milesPerDivision === 'number'
      ? formatNumber(getDivisionsPerBlock(milesPerDivision), this.locale, '1.0-4')
      : 'N/A';
  }
}
